import items from './browser';

export default items;
